const comments = [
  {
    name: '追番的小明',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20anime%20style%20avatar%20icon%20with%20warm%20orange%20and%20cream%20colors%2C%20abstract%20geometric%20design%2C%20clean%20and%20modern%2C%20no%20text%2C%20no%20face%2C%20circular%20composition&width=80&height=80&seq=avatar-user-1&orientation=squarish',
    text: '用了91樱花动漫快一年了，画质是真的清晰，1080P看着特别舒服。而且更新速度很快，日本那边播完没多久这边就能看了，追番党狂喜！',
    time: '2小时前',
  },
  {
    name: '二次元老宅',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20anime%20style%20avatar%20icon%20with%20warm%20pink%20and%20white%20colors%2C%20abstract%20geometric%20design%2C%20clean%20and%20modern%2C%20no%20text%2C%20no%20face%2C%20circular%20composition&width=80&height=80&seq=avatar-user-2&orientation=squarish',
    text: '对比过好几个动漫网站，最后留在了这里。没广告这点太重要了，之前在其他站点看番被弹窗烦到不行。91樱花动漫真的是纯净追番体验。',
    time: '5小时前',
  },
  {
    name: '樱花下的猫',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20anime%20style%20avatar%20icon%20with%20warm%20amber%20and%20cream%20colors%2C%20abstract%20geometric%20design%2C%20clean%20and%20modern%2C%20no%20text%2C%20no%20face%2C%20circular%20composition&width=80&height=80&seq=avatar-user-3&orientation=squarish',
    text: '手机上看也很流畅，通勤路上追番太方便了。资源也很全，老番新番都能找到，迷宫饭这种冷门美食番都有高清全集，爱了爱了。',
    time: '昨天',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实漫友的使用体验分享
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}